<template>
  <div>
    <chart-title chart-title="Chart device type firmware version"></chart-title>
    <nothing-to-show :is-loading="false" :is-there-date="userDeviceTypes.length > 0" >
      <b-row>
        <b-form-select v-model="selectedDeviceType" :options="options" class="mt-2 mx-4"></b-form-select>
      </b-row>

      <nothing-to-show :is-loading="isLoadedLocal" :is-there-date="deviceFWUpdates.labels.length > 0" >
        <DoughnutChart
          :chartData="deviceFWUpdates"
          :width=200
          :height=90
          :max-legend-lable-lenght="35"
          class="fix"
        />
      </nothing-to-show>
    </nothing-to-show>


  </div>
</template>

<script>
import DoughnutChart from "../views/charts/DoughnutChart";
import {randomHexColorWithArray} from 'random-hex-color-generator';
import ChartTitle from "./ChartTitle.vue";
import NothingToShow from "./NothingToShow.vue";

export default {
  name: "ChartFirmwareUpdateByDeviceType",
  components: {
    NothingToShow,
    ChartTitle,
    DoughnutChart
  },
  data: () => {
    return {
      selectedDeviceType: 41,
      deviceFWUpdates: {
        labels: [],
        datasets: []
      },
      isLoadedLocal: true,
    };
  },
  props: {
    userDeviceTypes: {
      type: [],
      required: true
    },
    isLoading: {
      type: Boolean,
    },
  },
  // mounted() {
  //   this.selectedDeviceType = _.take(this.userDeviceTypes)[0]?.id
  //   if (this.selectedDeviceType) {
  //     this.loadDeviceFWUpdatesData();
  //   }
  // },
  methods: {
    loadDeviceFWUpdatesData() {
      let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/summary/devices-fw-updates`;
      this.isLoadedLocal = true;
      return axios(
        {
          method: 'get',
          url,
          params: {
            device_type_id: this.selectedDeviceType,
          }
        }
      ).then(({data}) => {
        this.updateDeviceFWUpdates(data);
        return data;
      }).catch(e => {
        console.log(e);
      }).finally(
        () => {
          this.isLoadedLocal = false;
        }
      );
    },
    updateDeviceFWUpdates(response) {
      response.data.versions.sort(
        (a, b) => {
          return b.percentage - a.percentage;
        }
      );
      this.deviceFWUpdates = {
        labels: _.map(response.data.versions, 'version'),
        datasets: [
          {
            backgroundColor: randomHexColorWithArray( response.data.versions.length ),
            data: _.map(response.data.versions, 'percentage'),
          }
        ]
      };
      this.isLoadedLocal = false;
    },
  },
  computed: {
    options () {
      return this.userDeviceTypes.map(item => ({
        value: item.id,
        text: item.commercial_name
      }));
    },
  },
  watch: {
    selectedDeviceType: function (newSelectedDeviceType, oldSelectedDeviceType) {
      if (this.selectedDeviceType) {
        this.loadDeviceFWUpdatesData()
      }
    },
    userDeviceTypes: function (newUserDeviceTypes, oldUserDeviceTypes) {
      this.selectedDeviceType = _.take(this.userDeviceTypes)[0]?.id;
      if (this.selectedDeviceType) {
        this.loadDeviceFWUpdatesData();
      }
    }
  }
}
</script>

<style scoped>
.fix{
  margin-top: 40px;
  margin-bottom: 20px;
}

.chat-data-loading{
  text-align: center;
  padding: 120px 0;
}
</style>
